// â”€â”€â”€ CMSEditor â€“ visual section-based editor â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { cms } from "../../utils/api";
import "./CMSEditor.css";
import AdminLayout from "./AdminLayout";

// â”€â”€â”€ Page definitions â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const PAGES = [
  { tab: "terms", slug: "terms-conditions", title: "Terms & Conditions" },
  { tab: "privacy", slug: "privacy-policy", title: "Privacy Policy" },
  {
    tab: "instructor-terms",
    slug: "instructor-terms",
    title: "Instructor Terms",
  },
];

// â”€â”€â”€ HTML helpers â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
function stripTags(html) {
  return (html || "")
    .replace(/<[^>]+>/g, "")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&#39;/g, "'")
    .replace(/&nbsp;/g, " ")
    .trim();
}

/** Convert plain-text body (with "- " bullet syntax) â†’ HTML fragments */
function bodyToHtml(body) {
  const lines = body.split("\n").map((l) => l.trimEnd());
  let html = "";
  let inList = false;
  for (const line of lines) {
    if (!line) {
      if (inList) {
        html += "</ul>";
        inList = false;
      }
      continue;
    }
    if (line.startsWith("- ")) {
      if (!inList) {
        html += "<ul>";
        inList = true;
      }
      html += `<li>${line.slice(2)}</li>`;
    } else {
      if (inList) {
        html += "</ul>";
        inList = false;
      }
      html += `<p>${line}</p>`;
    }
  }
  if (inList) html += "</ul>";
  return html;
}

/** Convert sections array â†’ full HTML string */
function sectionsToHtml(sections) {
  return sections
    .map(
      (s) =>
        `<section class="legal-section"><h2>${s.heading}</h2>${bodyToHtml(s.body)}</section>`,
    )
    .join("\n\n");
}

/** Parse <section class="legal-section"> blocks â†’ sections array */
function htmlToSections(html) {
  if (!html || !html.trim()) return [{ heading: "Introduction", body: "" }];
  const sectionRx = /<section[^>]*>([\s\S]*?)<\/section>/gi;
  const result = [];
  let m;
  while ((m = sectionRx.exec(html)) !== null) {
    const inner = m[1];
    const heading = stripTags(
      (inner.match(/<h2[^>]*>([\s\S]*?)<\/h2>/i) || [])[1] || "",
    );
    // Remove h2, expand ul/li into "- item" lines, expand p into plain lines
    const bodyHtml = inner.replace(/<h2[^>]*>[\s\S]*?<\/h2>/i, "");
    const expanded = bodyHtml
      .replace(
        /<li[^>]*>([\s\S]*?)<\/li>/gi,
        (_, t) => `\nLI:${stripTags(t).trim()}`,
      )
      .replace(/<ul[^>]*>|<\/ul>/gi, "")
      .replace(
        /<p[^>]*>([\s\S]*?)<\/p>/gi,
        (_, t) => `\n${stripTags(t).trim()}`,
      );
    const bodyLines = expanded
      .split("\n")
      .map((l) => (l.startsWith("LI:") ? `- ${l.slice(3)}` : l.trim()))
      .filter((l, i, a) => l || a[i - 1] !== "");
    result.push({ heading, body: bodyLines.join("\n").trim() });
  }
  if (result.length) return result;
  // Fallback: bare h2+p pairs
  const chunks = html.split(/<h2[^>]*>/i).slice(1);
  for (const chunk of chunks) {
    const heading = stripTags(
      (chunk.match(/^([\s\S]*?)<\/h2>/i) || [])[1] || "",
    );
    const rest = chunk.replace(/^[\s\S]*?<\/h2>/i, "");
    const paras = [...rest.matchAll(/<p[^>]*>([\s\S]*?)<\/p>/gi)].map((p) =>
      stripTags(p[1]).trim(),
    );
    result.push({ heading, body: paras.join("\n") });
  }
  return result.length ? result : [{ heading: "Introduction", body: "" }];
}

// â”€â”€â”€ Component â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
export default function CMSEditor() {
  const { page: pageParam } = useParams();
  const navigate = useNavigate();

  const getPage = (tab) => PAGES.find((p) => p.tab === tab) || PAGES[0];
  const [activePage, setActivePage] = useState(() =>
    getPage(pageParam || "terms"),
  );
  const [sections, setSections] = useState([]);
  const [originalHtml, setOriginalHtml] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [versions, setVersions] = useState([]);
  const [preview, setPreview] = useState(false);

  const currentHtml = sectionsToHtml(sections);
  const hasChanges = currentHtml !== originalHtml;

  const load = useCallback(async (pg) => {
    setLoading(true);
    setError(null);
    try {
      const data = await cms.getContent(pg.slug);
      const raw =
        typeof data?.content?.content === "string"
          ? data.content.content
          : typeof data?.content === "string"
            ? data.content
            : "";
      setOriginalHtml(raw);
      setSections(htmlToSections(raw));
    } catch (e) {
      if (e?.status === 404) {
        setOriginalHtml("");
        setSections([{ heading: "Introduction", body: "" }]);
      } else {
        setError("Failed to load content.");
      }
    } finally {
      setLoading(false);
    }
  }, []);

  const loadVersions = useCallback(async (pg) => {
    try {
      const data = await cms.getVersionHistory(pg.slug);
      setVersions(data?.versions || data || []);
    } catch {
      setVersions([]);
    }
  }, []);

  useEffect(() => {
    load(activePage);
    loadVersions(activePage);
  }, [activePage, load, loadVersions]);

  const switchPage = (pg) => {
    if (
      hasChanges &&
      !window.confirm("You have unsaved changes. Switch anyway?")
    )
      return;
    setActivePage(pg);
    setPreview(false);
    navigate(`/ft-portal/cms/${pg.tab}`);
  };

  const save = async () => {
    setSaving(true);
    setError(null);
    try {
      await cms.updateContent(activePage.slug, {
        content: currentHtml,
        is_published: true,
      });
      setOriginalHtml(currentHtml);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
      loadVersions(activePage);
    } catch {
      setError("Failed to save.");
    } finally {
      setSaving(false);
    }
  };

  const revert = async (version) => {
    if (!window.confirm("Restore this version?")) return;
    setSaving(true);
    try {
      await cms.revertToVersion(activePage.slug, version);
      await load(activePage);
      await loadVersions(activePage);
      setSuccess(true);
      setTimeout(() => setSuccess(false), 3000);
    } catch {
      setError("Failed to restore version.");
    } finally {
      setSaving(false);
    }
  };

  const updateSection = (idx, field, val) =>
    setSections((sc) =>
      sc.map((s, i) => (i === idx ? { ...s, [field]: val } : s)),
    );

  const addSection = (afterIdx) =>
    setSections((sc) => {
      const copy = [...sc];
      copy.splice(afterIdx + 1, 0, { heading: "New Section", body: "" });
      return copy;
    });

  const removeSection = (idx) => {
    if (sections.length === 1) return;
    if (!window.confirm("Remove this section?")) return;
    setSections((sc) => sc.filter((_, i) => i !== idx));
  };

  const moveSection = (idx, dir) =>
    setSections((sc) => {
      const copy = [...sc];
      const target = idx + dir;
      if (target < 0 || target >= copy.length) return copy;
      [copy[idx], copy[target]] = [copy[target], copy[idx]];
      return copy;
    });

  const fmt = (d) =>
    d
      ? new Date(d).toLocaleString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "-";

  return (
    <AdminLayout pageTitle="CMS Editor">
      <div
        style={{
          maxWidth: 1100,
          margin: "0 auto",
          padding: "24px 16px",
          fontFamily: "sans-serif",
        }}
      >
        {/* Header */}
        <div style={{ marginBottom: 20 }}>
          <h1 style={{ margin: "0 0 16px", fontSize: 22, fontWeight: 700 }}>
            Content Management
          </h1>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {PAGES.map((pg) => (
              <button
                key={pg.tab}
                onClick={() => switchPage(pg)}
                style={{
                  padding: "8px 20px",
                  borderRadius: 8,
                  fontWeight: 600,
                  fontSize: 14,
                  cursor: "pointer",
                  border: "none",
                  background: activePage.tab === pg.tab ? "#1043A0" : "#f1f3f9",
                  color: activePage.tab === pg.tab ? "#fff" : "#374151",
                }}
              >
                {pg.title}
              </button>
            ))}
          </div>
        </div>

        {error && (
          <div
            style={{
              background: "#fff0f0",
              border: "1px solid #fca5a5",
              borderRadius: 8,
              padding: "10px 16px",
              marginBottom: 14,
              color: "#b91c1c",
            }}
          >
            {error}
          </div>
        )}
        {success && (
          <div
            style={{
              background: "#f0fdf4",
              border: "1px solid #86efac",
              borderRadius: 8,
              padding: "10px 16px",
              marginBottom: 14,
              color: "#15803d",
            }}
          >
            Saved successfully.
          </div>
        )}

        <div className="cms-editor-grid">
          {/* Main editor */}
          <div>
            {/* Toolbar */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                marginBottom: 16,
                flexWrap: "wrap",
              }}
            >
              <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, flex: 1 }}>
                {activePage.title}
                {hasChanges && (
                  <span
                    style={{
                      marginLeft: 10,
                      fontSize: 12,
                      color: "#f59e0b",
                      fontWeight: 600,
                    }}
                  >
                    Unsaved changes
                  </span>
                )}
              </h2>
              <button
                onClick={() => setPreview((p) => !p)}
                style={{
                  padding: "7px 16px",
                  borderRadius: 7,
                  border: "1px solid #cbd5e1",
                  background: "#f8fafc",
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: 13,
                }}
              >
                {preview ? "Edit" : "Preview"}
              </button>
              <button
                onClick={save}
                disabled={saving || !hasChanges}
                style={{
                  padding: "7px 18px",
                  borderRadius: 7,
                  border: "none",
                  background: !hasChanges || saving ? "#cbd5e1" : "#1043A0",
                  color: "#fff",
                  cursor: !hasChanges || saving ? "default" : "pointer",
                  fontWeight: 700,
                  fontSize: 13,
                }}
              >
                {saving ? "Saving..." : "Save Changes"}
              </button>
            </div>

            {loading ? (
              <div
                style={{ textAlign: "center", padding: 40, color: "#64748b" }}
              >
                Loading content...
              </div>
            ) : preview ? (
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #e2e8f0",
                  borderRadius: 10,
                  padding: "28px 32px",
                  minHeight: 300,
                }}
              >
                <div dangerouslySetInnerHTML={{ __html: currentHtml }} />
              </div>
            ) : (
              <div>
                {sections.map((sec, idx) => (
                  <div
                    key={idx}
                    style={{
                      background: "#fff",
                      border: "1px solid #e2e8f0",
                      borderRadius: 10,
                      marginBottom: 12,
                      overflow: "hidden",
                    }}
                  >
                    {/* Section header bar */}
                    <div
                      style={{
                        background: "#f8fafc",
                        borderBottom: "1px solid #e2e8f0",
                        padding: "8px 14px",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                      }}
                    >
                      <span
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: "#94a3b8",
                          minWidth: 28,
                        }}
                      >
                        {idx + 1}.
                      </span>
                      <input
                        value={sec.heading}
                        onChange={(e) =>
                          updateSection(idx, "heading", e.target.value)
                        }
                        placeholder="Section heading..."
                        style={{
                          flex: 1,
                          minWidth: 0,
                          border: "1px solid #cbd5e1",
                          borderRadius: 6,
                          padding: "5px 10px",
                          fontSize: 14,
                          fontWeight: 600,
                          color: "#1e293b",
                        }}
                      />
                      <button
                        onClick={() => moveSection(idx, -1)}
                        disabled={idx === 0}
                        title="Move up"
                        style={{
                          background: "none",
                          border: "none",
                          cursor: idx === 0 ? "default" : "pointer",
                          color: idx === 0 ? "#cbd5e1" : "#64748b",
                          fontSize: 18,
                          padding: "2px 4px",
                        }}
                      >
                        &#8593;
                      </button>
                      <button
                        onClick={() => moveSection(idx, 1)}
                        disabled={idx === sections.length - 1}
                        title="Move down"
                        style={{
                          background: "none",
                          border: "none",
                          cursor:
                            idx === sections.length - 1 ? "default" : "pointer",
                          color:
                            idx === sections.length - 1 ? "#cbd5e1" : "#64748b",
                          fontSize: 18,
                          padding: "2px 4px",
                        }}
                      >
                        &#8595;
                      </button>
                      <button
                        onClick={() => removeSection(idx)}
                        title="Delete this section"
                        disabled={sections.length === 1}
                        style={{
                          background: sections.length === 1 ? "#f8fafc" : "#fff5f5",
                          border: `1px solid ${sections.length === 1 ? "#e2e8f0" : "#fca5a5"}`,
                          borderRadius: 6,
                          cursor: sections.length === 1 ? "not-allowed" : "pointer",
                          color: sections.length === 1 ? "#cbd5e1" : "#ef4444",
                          fontSize: 12,
                          fontWeight: 600,
                          padding: "3px 10px",
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          whiteSpace: "nowrap",
                        }}
                      >
                        🗑 Delete
                      </button>
                    </div>

                    {/* Body editor */}
                    <div style={{ padding: "12px 14px" }}>
                      <textarea
                        value={sec.body}
                        onChange={(e) =>
                          updateSection(idx, "body", e.target.value)
                        }
                        rows={Math.max(
                          3,
                          (sec.body.match(/\n/g) || []).length + 2,
                        )}
                        placeholder={
                          'Write paragraph text here.\n\nFor bullet points, start a line with "- " e.g.\n- First point\n- Second point'
                        }
                        style={{
                          width: "100%",
                          border: "1px solid #e2e8f0",
                          borderRadius: 6,
                          padding: "10px 12px",
                          fontSize: 13,
                          lineHeight: 1.7,
                          color: "#334155",
                          resize: "vertical",
                          boxSizing: "border-box",
                          fontFamily: "inherit",
                          outline: "none",
                        }}
                      />
                      <p
                        style={{
                          margin: "4px 0 0",
                          fontSize: 11,
                          color: "#94a3b8",
                        }}
                      >
                        Tip: Start a line with{" "}
                        <code
                          style={{
                            background: "#f1f5f9",
                            padding: "1px 5px",
                            borderRadius: 4,
                          }}
                        >
                          -{" "}
                        </code>{" "}
                        to create a bullet point.
                      </p>
                    </div>

                    {/* Add section below */}
                    <div
                      style={{
                        borderTop: "1px dashed #e2e8f0",
                        padding: "6px 14px",
                        textAlign: "center",
                      }}
                    >
                      <button
                        onClick={() => addSection(idx)}
                        style={{
                          background: "none",
                          border: "none",
                          color: "#1043A0",
                          cursor: "pointer",
                          fontSize: 12,
                          fontWeight: 600,
                          padding: "2px 8px",
                        }}
                      >
                        + Add section below
                      </button>
                    </div>
                  </div>
                ))}

                {sections.length === 0 && (
                  <button
                    onClick={() => addSection(-1)}
                    style={{
                      width: "100%",
                      padding: 16,
                      border: "2px dashed #cbd5e1",
                      borderRadius: 10,
                      background: "none",
                      color: "#64748b",
                      cursor: "pointer",
                      fontSize: 14,
                      fontWeight: 600,
                    }}
                  >
                    + Add First Section
                  </button>
                )}
              </div>
            )}
          </div>

          {/* Sidebar */}
          <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            {/* Version history */}
            <div
              style={{
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 10,
                padding: 16,
              }}
            >
              <h3 style={{ margin: "0 0 12px", fontSize: 14, fontWeight: 700 }}>
                Version History
              </h3>
              {versions.length === 0 ? (
                <p style={{ color: "#94a3b8", fontSize: 13, margin: 0 }}>
                  No saved versions yet.
                </p>
              ) : (
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 8 }}
                >
                  {versions.slice(0, 10).map((v) => (
                    <div
                      key={v.id || v.version}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 8,
                        fontSize: 12,
                      }}
                    >
                      <div>
                        <strong style={{ color: "#1e293b" }}>
                          v{v.version}
                        </strong>
                        <span style={{ color: "#94a3b8", display: "block" }}>
                          {fmt(v.changed_at || v.created_at)}
                        </span>
                      </div>
                      <button
                        onClick={() => revert(v.version)}
                        style={{
                          background: "#f1f3f9",
                          border: "1px solid #dde",
                          borderRadius: 6,
                          padding: "3px 10px",
                          cursor: "pointer",
                          fontSize: 11,
                          fontWeight: 600,
                        }}
                      >
                        Restore
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Stats */}
            <div
              style={{
                background: "#fff",
                border: "1px solid #e2e8f0",
                borderRadius: 10,
                padding: 16,
              }}
            >
              <h3 style={{ margin: "0 0 10px", fontSize: 14, fontWeight: 700 }}>
                Stats
              </h3>
              {[
                ["Sections", sections.length],
                [
                  "Words",
                  currentHtml
                    .replace(/<[^>]+>/g, "")
                    .split(/\s+/)
                    .filter(Boolean).length,
                ],
                ["Characters", currentHtml.replace(/<[^>]+>/g, "").length],
              ].map(([label, val]) => (
                <div
                  key={label}
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: 13,
                    padding: "4px 0",
                    borderBottom: "1px solid #f1f5f9",
                  }}
                >
                  <span style={{ color: "#64748b" }}>{label}</span>
                  <strong>{val}</strong>
                </div>
              ))}
            </div>

            {/* Help */}
            <div
              style={{
                background: "#f8faff",
                border: "1px solid #dde3f8",
                borderRadius: 10,
                padding: 16,
                fontSize: 12,
                color: "#475569",
                lineHeight: 1.7,
              }}
            >
              <strong
                style={{ color: "#1043A0", display: "block", marginBottom: 6 }}
              >
                How to edit
              </strong>
              <ul style={{ margin: 0, paddingLeft: 16 }}>
                <li>Each card is one numbered section</li>
                <li>Edit the heading in the top bar</li>
                <li>Write content in the text area below</li>
                <li>
                  Use{" "}
                  <code
                    style={{
                      background: "#eef",
                      padding: "0 3px",
                      borderRadius: 3,
                    }}
                  >
                    - text
                  </code>{" "}
                  for bullet points
                </li>
                <li>Use the arrows to reorder sections</li>
                <li>Click &times; to delete a section</li>
                <li>Click "Add section below" to insert</li>
                <li>Click Preview to see the result</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}

// export default CMSEditor;
